import { HTMLAttributes, ReactNode, useRef, useState } from 'react'
import styles from './CheckboxGroup.module.scss'
import { classNames } from '@/src/helpers/component'
import Img from '@/src/components/common/Img/Img'

export type CheckboxOption =
  | string
  | {
      icon?: string
      display?: ReactNode
      value: string
    }

export default function CheckboxGroupClient({
  options,
  name,
  className,
  values,
  required,
  ..._
}: HTMLAttributes<HTMLDivElement> & {
  values?: string[]
  className?: string
  name: string
  options: CheckboxOption[]
  required?: number
}) {
  const [currentValues, setCurrentValues] = useState<string[]>(values ?? [])
  const ref = useRef<HTMLDivElement>(null)

  return (
    <div ref={ref} {..._} className={classNames(styles.container, className)}>
      {options.map((_, idx) => {
        if (typeof _ === 'string') _ = { display: _, value: _ }
        if (_.display === undefined) _.display = _.value
        return (
          <label key={idx}>
            <input
              type={'checkbox'}
              value={_.value}
              name={name}
              data-required={JSON.stringify([required ?? 0, currentValues.length])}
              required={(required ?? 0) > 0 && currentValues.length === 0}
              checked={currentValues.includes(_.value)}
              onChange={e => {
                if (e.currentTarget.checked) {
                  currentValues.push(_.value)
                } else {
                  currentValues.splice(currentValues.indexOf(_.value), 1)
                }
                setCurrentValues([...currentValues])
              }}
            />
            {_.icon && <Img src={_.icon} />}
            {_.display}
          </label>
        )
      })}
    </div>
  )
}
